import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PublicDrehvorbereitung } from "@/pages/PublicDrehvorbereitung";

/**
 * Bewusst **außerhalb** von `_angemeldet` — aus demselben Grund wie
 * `/drehbuch/$token`: Die Drehvorbereitung geht an Beteiligte ohne Konto
 * (Protagonisten, externe Gewerke, Erziehungsberechtigte), die hier lesen,
 * kommentieren und die Einwilligung digital unterschreiben. Der Token in der
 * Adresse ist der Zugang. Aktuell Demo-Daten ("demo" = Kombidreh,
 * "testimonial" = schlanke Variante) — sobald echte Pläne kommen, braucht es
 * signierte, ablaufende Tokens.
 *
 * `?modus=drehtag` öffnet direkt die Drehtag-Checkliste — der Link, den der
 * Videograf am Drehtag auf dem Handy aufmacht.
 */
const suchSchema = z.object({
	modus: z.enum(["dokument", "drehtag"]).optional(),
});

export const Route = createFileRoute("/drehplan/$token")({
	validateSearch: suchSchema,
	component: DrehplanSeite,
});

function DrehplanSeite() {
	const { token } = Route.useParams();
	const { modus } = Route.useSearch();
	return <PublicDrehvorbereitung token={token} initialModus={modus ?? "dokument"} />;
}
